module.exports = __webpack_public_path__ + "static/img/produto_g.adb8617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_limao/produto_g.png
// module id = TMG1
// module chunks = 0